import {
	DocumentWorkflowInstanceStatus,
	DocumentWorkflowTemplateType,
} from '@dealstack/shared/lib/generated';

export const isReviewDocument = (templateType: DocumentWorkflowTemplateType | undefined): boolean =>
	templateType === DocumentWorkflowTemplateType.READ_ONLY;

export const canReplaceDocumentFile = ({
	isSupport,
	workflowStatus,
}: {
	isSupport: boolean;
	workflowStatus: DocumentWorkflowInstanceStatus;
}): boolean => isSupport && workflowStatus === DocumentWorkflowInstanceStatus.COMPLETED;
